import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {NotFoundAssistantError} from '../Errors/NotFoundAssistantError.js'
import {HTTPAssistantRepository} from '../Repositories/HTTPAssistantRepository.js'

class CheckExistingAssistantChatUseCase extends UseCase {
  #assistantRepository

  #handleError(error) {
    if (error instanceof NotFoundAssistantError) return Promise.reject(error)
    return Promise.reject(
      DomainSharedError.isDomainError({error}) ? error : DomainSharedError.createGenericError({cause: error})
    )
  }

  constructor({assistantRepository}) {
    super()
    this.#assistantRepository = assistantRepository
  }

  static create({config}) {
    return new CheckExistingAssistantChatUseCase({
      config,
      assistantRepository: HTTPAssistantRepository.create({config})
    })
  }

  @tracer({metric: 'CheckExistingAssistantChatUseCase#execute'})
  @AsyncInlineError()
  async execute({chatId}) {
    try {
      const assistantResponse = await this.#assistantRepository.checkChat({chatId})
      return assistantResponse?.toJSON?.()
    } catch (error) {
      return this.#handleError(error)
    }
  }
}

export const factory = CheckExistingAssistantChatUseCase.create
